var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Media Files ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-form",
                    [
                      _c("v-file-input", {
                        attrs: {
                          outlined: "",
                          placeholder: "Select an image for your logo.",
                          hint:
                            "Preferred sizes: Vertical: 160px * 160px Horizontal: 350px * 75px",
                          "persistent-hint": "",
                          "show-size": "",
                          "small-chips": "",
                          "prepend-icon": "mdi-paperclip",
                          accept: _vm.allowed_files,
                          loading: _vm.loading.logoFile,
                          disabled: _vm.logoFile.length >= 1
                        },
                        on: {
                          change: function change($event) {
                            return _vm.uploadFiles(
                              _vm.files.logoFile,
                              "logoFile"
                            )
                          }
                        },
                        model: {
                          value: _vm.files.logoFile,
                          callback: function callback($$v) {
                            _vm.$set(_vm.files, "logoFile", $$v)
                          },
                          expression: "files.logoFile"
                        }
                      }),
                      _c(
                        "v-chip-group",
                        _vm._l(_vm.logoFile, function(file, key) {
                          return _c(
                            "v-chip",
                            {
                              key: key,
                              attrs: {
                                close: ""
                              },
                              on: {
                                "click:close": function clickClose($event) {
                                  return _vm.removeFile(file.id, "logoFile")
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(file.name) + " ")]
                          )
                        }),
                        1
                      ),
                      _c("v-file-input", {
                        attrs: {
                          outlined: "",
                          placeholder: "Select an image for the header.",
                          hint: "Preferred sizes: 1280px * 768px",
                          "persistent-hint": "",
                          "show-size": "",
                          "small-chips": "",
                          "prepend-icon": "mdi-paperclip",
                          accept: _vm.allowed_files,
                          loading: _vm.loading.headerFile,
                          disabled: _vm.headerFile.length >= 1
                        },
                        on: {
                          change: function change($event) {
                            return _vm.uploadFiles(
                              _vm.files.headerFile,
                              "headerFile"
                            )
                          }
                        },
                        model: {
                          value: _vm.files.headerFile,
                          callback: function callback($$v) {
                            _vm.$set(_vm.files, "headerFile", $$v)
                          },
                          expression: "files.headerFile"
                        }
                      }),
                      _c(
                        "v-chip-group",
                        _vm._l(_vm.headerFile, function(file, key) {
                          return _c(
                            "v-chip",
                            {
                              key: key,
                              attrs: {
                                close: ""
                              },
                              on: {
                                "click:close": function clickClose($event) {
                                  return _vm.removeFile(file.id, "headerFile")
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(file.name) + " ")]
                          )
                        }),
                        1
                      ),
                      _c("v-file-input", {
                        attrs: {
                          outlined: "",
                          placeholder:
                            "Select an image for the Services section.",
                          hint: "Preferred sizes: 512px * 512px",
                          "persistent-hint": "",
                          "show-size": "",
                          "small-chips": "",
                          "prepend-icon": "mdi-paperclip",
                          accept: _vm.allowed_files,
                          loading: _vm.loading.servicesFile,
                          disabled: _vm.servicesFile.length >= 1
                        },
                        on: {
                          change: function change($event) {
                            return _vm.uploadFiles(
                              _vm.files.servicesFile,
                              "servicesFile"
                            )
                          }
                        },
                        model: {
                          value: _vm.files.servicesFile,
                          callback: function callback($$v) {
                            _vm.$set(_vm.files, "servicesFile", $$v)
                          },
                          expression: "files.servicesFile"
                        }
                      }),
                      _c(
                        "v-chip-group",
                        _vm._l(_vm.servicesFile, function(file, key) {
                          return _c(
                            "v-chip",
                            {
                              key: key,
                              attrs: {
                                close: ""
                              },
                              on: {
                                "click:close": function clickClose($event) {
                                  return _vm.removeFile(file.id, "servicesFile")
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(file.name) + " ")]
                          )
                        }),
                        1
                      ),
                      _c("v-file-input", {
                        attrs: {
                          outlined: "",
                          placeholder: "Select an image for the About section.",
                          hint: "Preferred sizes: 640px * 570px",
                          "persistent-hint": "",
                          "show-size": "",
                          "small-chips": "",
                          "prepend-icon": "mdi-paperclip",
                          accept: _vm.allowed_files,
                          loading: _vm.loading.aboutFile,
                          disabled: _vm.aboutFile.length >= 1
                        },
                        on: {
                          change: function change($event) {
                            return _vm.uploadFiles(
                              _vm.files.aboutFile,
                              "aboutFile"
                            )
                          }
                        },
                        model: {
                          value: _vm.files.aboutFile,
                          callback: function callback($$v) {
                            _vm.$set(_vm.files, "aboutFile", $$v)
                          },
                          expression: "files.aboutFile"
                        }
                      }),
                      _c(
                        "v-chip-group",
                        _vm._l(_vm.aboutFile, function(file, key) {
                          return _c(
                            "v-chip",
                            {
                              key: key,
                              attrs: {
                                close: ""
                              },
                              on: {
                                "click:close": function clickClose($event) {
                                  return _vm.removeFile(file.id, "aboutFile")
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(file.name) + " ")]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }